export interface ApiResponse {
  code: number;
  message: string;
}

export interface InterceptError {
  message: string;
  trackingNumber: string;
}

export const EnterpriseErrorMessage = 'Do not Process. Return to UPS';
export const InterceptErrorMessage = 'DO NOT DELIVER!';
export const InvalidNumberMessage = 'Invalid Tracking Number';

export type ApiErrorResponse = ApiResponse;
